export default "__VITE_ASSET__51797236__"